module.exports = __webpack_public_path__ + "img/dino_40l.acd2ec14.png";